import { useEffect } from 'react';

import { Navigate } from '@sorare/routing';

import { useGetSelectClubPath } from '@sorare/core/src/hooks/onboarding/useGetSelectClubPath';

import { useFootballEvents } from '@sorare/gameplay/src/lib/events';

const ProOnboardingPage = () => {
  const track = useFootballEvents();
  const selectClubPath = useGetSelectClubPath();
  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  return <Navigate to={selectClubPath} replace keepSearchParams />;
};

export default ProOnboardingPage;
